import { Avatar, AvatarProps, useTheme } from '@mui/material';
import React from 'react';

interface Props extends Omit<AvatarProps, 'children'> {
  label: string;
}

const GroupAvatar = React.forwardRef<HTMLDivElement, Props>(({ label, sx, ...rest }, ref) => {
  const theme = useTheme();
  return (
    <Avatar
      ref={ref}
      variant="circular"
      {...rest}
      sx={{
        width: 24,
        height: 24,
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText,
        fontSize: theme.typography.caption.fontSize,
        boxSizing: 'content-box',
        border: `2px solid ${theme.palette.background.paper}`,
        ...sx
      }}
    >
      {label}
    </Avatar>
  );
});

GroupAvatar.displayName = 'GroupAvatar';

export default GroupAvatar;
